import {selectNavOption} from "../helpers/nav_option_helpers";
import {clearExperienceMarker, clearNavOption} from "../helpers/commit_helpers";

export default function filterRouteRequested(sm, mapFilter) {
    const navOption = mapFilter?.onlineAppNavOption;
    if (navOption) {
        selectNavOption(sm, navOption);
        navOption.fireSelectedWithRouteRequestEvent(); // Event to be picked up by the Nav's PaneOptionComponent event listener.
    } else {
        if(isCurrentNavOption(sm)) clearNavOption(sm);
    }

    // If there is an experienceMarker open then we close it…
    if(isCurrentExperienceMarker(sm)) { clearExperienceMarker(sm) }

}

// Private…

function isCurrentExperienceMarker(sm) {
    return !!sm.state['experienceMarker'];
}

function isCurrentNavOption(sm) {
    return !!sm.state['navOption'];
}